import VueRouter from 'vue-router';

import routes from '@/router/data.js';

import {
  Icon
} from 'ant-design-vue';

import Image from '@/components/Image.vue';
import TreeSelect from '@/components/TreeSelect.vue';
import Editor from '@/components/Editor.vue';
import BatchSelectHouse from '@/components/BatchSelectHouse.vue';

import UserService from '@/io/user.js';

import {
  $normalMargin,
  $formLabelCol,
  $formWrapperCol,
  $formEmptyLabelWrapperCol,
  $beforeFormSubmit,
  $afterFormSubmit,
  $getCookie,
  $setCookie,
  $delCookie,
  $debounce,
  $throttle,
  $createNewVariable,
  $objToArray,
  $depthSearchTree,
  $breadthSearchTree,
  $strToObj,
  $houseTreeData,
  $beforeUpload,
  $dateFormat
} from '@/plugins/utils.js';

let install = (Vue, options = {}) => {

  Vue.prototype.$normalMargin = $normalMargin;

  Vue.prototype.$formLabelCol = $formLabelCol;

  Vue.prototype.$formWrapperCol = $formWrapperCol;

  Vue.prototype.$formEmptyLabelWrapperCol = $formEmptyLabelWrapperCol;

  Vue.prototype.$beforeFormSubmit = $beforeFormSubmit;

  Vue.prototype.$afterFormSubmit = $afterFormSubmit;

  Vue.prototype.$getCookie = $getCookie;

  Vue.prototype.$setCookie = $setCookie;

  Vue.prototype.$delCookie = $delCookie;

  Vue.prototype.$debounce = $debounce;

  Vue.prototype.$throttle = $throttle;
  
  Vue.prototype.$createNewVariable = $createNewVariable;

  Vue.prototype.$objToArray = $objToArray;

  Vue.prototype.$depthSearchTree = $depthSearchTree;

  Vue.prototype.$breadthSearchTree = $breadthSearchTree;

  Vue.prototype.$strToObj = $strToObj;

  Vue.prototype.$houseTreeData = $houseTreeData;

  Vue.prototype.$beforeUpload = $beforeUpload;

  Vue.prototype.$dateFormat = $dateFormat;

  Vue.prototype.$uploadUrl = `${process.env.VUE_APP_DOMAIN}/aggregation/imageupload`;

  Vue.component(Image.name, Image);

  Vue.component(TreeSelect.name, TreeSelect);

  Vue.component(Editor.name, Editor);

  Vue.component(BatchSelectHouse.name, BatchSelectHouse);

  Vue.component('dy-icon', Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2109683_7w882924fth.js'
  }));

  Vue.mixin({
    data() {
      return {
        filterKeyword: $debounce((sourceData, dataSearchName, keyword, nameKey = 'name', childrenKey = 'children') => {
          let formatData = data => {
            if (!data[childrenKey]) {
              data[childrenKey] = [];
            }
            if (data[childrenKey].length) {
              data[childrenKey] = $createNewVariable(data[childrenKey].filter(value => formatData(value)));
            }
            return data[nameKey].indexOf(keyword) > -1 || !!data[childrenKey].length;
          }
          let searchNameArr = dataSearchName.split('.');
          let target = this;
          searchNameArr.forEach((value, index) => {
            if (index === searchNameArr.length - 1) {
              target[value] = keyword ? $createNewVariable(sourceData).filter(value => formatData(value)) : [];
            } else {
              target = target[value];
            }
          })
        })
      }
    },
    computed: {
      isPlatformRole() {
        return this.$store.state.userInfo && this.$store.state.userInfo.is_platform_role;
      }
    },
    methods: {
      //导入信息
      impExcel(e) {
        const that = this
        let fileName = e.target.files[0]
        return new Promise(function (resolve, reject) {
          let reader = new FileReader()
          //启动函数
          reader.readAsBinaryString(fileName)
          reader.onload = function (e) {
            const workbook = XLSX.read(e.target.result, { type: 'binary' })
            const firstSheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[firstSheetName]
            const results = XLSX.utils.sheet_to_json(worksheet)
            resolve(results)
          }
        })
      },
      // 转换日期
      formatDate(numb, format) {
        const old = numb - 1
        const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60)
        const time = new Date(1900, 0, old, 0, 0, t)
        const year = time.getFullYear()
        const month = time.getMonth() + 1
        const date = time.getDate()
        return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
      },
      initRouter(extraRoutes = []) {
        this.resetRouter();
        extraRoutes.concat(routes).forEach(val => {
          this.$router.addRoute(val);
        });
      },
      resetRouter() {
        let router = new VueRouter({});
        this.$router.matcher = router.matcher;
      },
      logout() {
        UserService.logout().then(res => {
          this.$store.commit('setUserInfo', null);
          this.$store.commit('setCommunity', null);
          this.$store.commit('setMenuList', null);
          this.$delCookie('token');
          this.$delCookie('communityId');
          this.initRouter();
          this.$store.commit('setRedirectUrl', null);
          // this.$router.push('/entrance');
        }).catch(err => { });
      }
    }
  });

};

export default {
  install
};